const KEY = 'scrivar_desktop_processing';
const EVENT = 'scrivar:processing-mode';

export function getProcessingMode() {
  try { return localStorage.getItem(KEY) === 'cloud' ? 'cloud' : 'local'; }
  catch { return 'local'; }
}

export function setProcessingMode(mode) {
  localStorage.setItem(KEY, mode === 'cloud' ? 'cloud' : 'local');
  window.dispatchEvent(new Event(EVENT));
}

export function subscribeProcessingMode(callback) {
  window.addEventListener(EVENT, callback);
  window.addEventListener('storage', callback);
  return () => { window.removeEventListener(EVENT, callback); window.removeEventListener('storage', callback); };
}
